import { Button, Card, InputNumber, Radio } from "antd";
import React from "react";


const PaymentMethod = (props) => {
    const { } = props;

    return <Card className="payment-card">
    <div className="payment_content">
        <div className="card-heading">
        Payment Method
        </div>
        <div className="content_item">
          <div className="content_labels">
            <div>Visa ending in 8673</div>
            <label className="info_label">(Primary)</label>
          </div>
          <div><Button type="primary" className="plan_btn">Update</Button></div>
        </div>
    </div>
  </Card>
};
export default PaymentMethod;